import { useMutation } from 'react-query'
import { getCountries } from '../services/country'

export function useGetCountries() {
  return useMutation(() => getCountries())
}